import React from "react";
import { DropshippingLanguageContext } from "../i18n";
import DropshippingModuleTabs from "../../../components/SIdeDrawer/DropshippingModuleTabs";

// Language context for every Dropshipping In / Provider page, rendered INSIDE the real <Layout>.
// The module tab strip (Providers, My Products, Inventory, Orders, PA, Provider Center pages...) is
// rendered here, at the top of every page in this ecosystem -- its original place. It also still
// lives in the Filter drawer (components/SIdeDrawer/DrawerNavGroups) for narrow/mobile access; both
// read the SAME drawerNavConfig data, never a duplicated menu.
const DropshippingInterneLayout = ({ infoSource, children }) => (
  <DropshippingLanguageContext.Provider value={infoSource}>
    <DropshippingModuleTabs infoSource={infoSource} />
    {children}
  </DropshippingLanguageContext.Provider>
);

export default DropshippingInterneLayout;
